export default __webpack_public_path__ + "static/media/DailyThing_01.b52004bc.png";